import { setCookie, getCookie } from './chromeApi';

const APP_URL = process.env.APP_URL;

export const setOhCookies = (name: string, value: unknown, extra = {}): void => {
  return setCookie({
    url: APP_URL,
    name,
    value:
      typeof value === 'object' ? JSON.stringify(value) : String(value),
    expirationDate: Math.round(Date.now() / 1000 + 31536000),
    secure: !APP_URL.match('localhost'),
    sameSite: 'lax',
    ...extra
  });
};

export const getOhCookie = async (name: string): Promise<string> => {
  try {
    const result = await getCookie({ url: APP_URL, name });
    return result ? result.value : null;
  } catch (err) {
    console.error('getOhCookie', err);
    return null;
  }
};

export const getNumberTypeCookie = (name: string): Promise<number> =>
  getOhCookie(name).then((cookie) => Number(cookie) || null);

// export const removeCookie = (name) =>
//   chrome.cookies.remove({ url: query.url, name });
